import * as React from 'react';
import { observer } from 'mobx-react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { TabLanguageInlineView } from 'src/core/ui/language/tab-language-inline.view';

interface ProductServiceTypeListViewProps extends ComponentViewProps<DataSet<ProductServiceTypeItem>> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	category: ProductCategoryItem;
	defaultLanguage: string;
	features: { item1: string, item2: string }[];
}

@observer
export class ProductServiceTypeListView extends React.Component<ProductServiceTypeListViewProps, {}> {
	private id = -1;

	private columns: Column[] = [
		{
			key: 'displayName',
			dataIndex: 'displayName',
			title: 'Name',
			editable: (text: string, record: ProductServiceTypeItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					const array = [{ title: 'Title', dynamicProperties: record.dynamicProperties.displayName, required: true }];
					return (
						<TabLanguageInlineView
							dynamicProperties={array}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							model={record}
						/>
					);
				}

				return record.dynamicProperties.displayName.en || "";
			}
		}
	];

	constructor(props: ProductServiceTypeListViewProps) {
		super(props);
	}

	create = (): Promise<ProductServiceTypeItem> => {
		return this.props.model.create(() => ({
			categoryId: this.props.category.id,
			dynamicProperties: { displayName: {} },
			id: this.id--
		} as any))
			.then(res => {
			res.entity.category = this.props.category.entity;
			res.dynamicProperties['displayName'][this.props.defaultLanguage] = '';
			this.props.category.services = this.props.category.services ? this.props.category.services : []
			this.props.category.services.push(res);
			return res;
		});
	};

	render(): JSX.Element {
		const { model, features, mode, setBusy } = this.props;
		if (model == null) {
			return null;
		}

		const columns: Column[] = [
			...this.columns,
			...features.map((f) => {
				const name = f.item1.substr(0, 1).toLowerCase() + f.item1.substr(1);
				return {
					key: name,
					dataIndex: name,
					title: f.item2,
					editable: (text: string, record: ProductServiceTypeItem, index: number, isSelected: boolean) => {
						if (record.dynamicProperties == null) {
							record.dynamicProperties = {
								features: {},
							};
						} else if (record.dynamicProperties.features == null) {
							record.dynamicProperties.features = {};
						}
						return (
							<BooleanView
								mode={isSelected ? 'edit' : 'display'}
								label={null}
								required={true}
								size="small"
								value={record.dynamicProperties.features[name]}
								onChanged={(e) => record.dynamicProperties.features[name] = e}
							/>
						);
					}
				};
			})];

		return (
			<DataTableView
				mode={mode}
				setBusy={setBusy}
				columns={columns}
				model={model}
				hideToolbar={ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
				createNewItem={this.create}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-service-types/list/product-service-type-list.view.tsx